module.exports = __webpack_public_path__ + "static/img/icon7.d39e0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon7.png
// module id = H9bh
// module chunks = 6